.eu{color:var(--brand-primary);}